const header = document.querySelector('header');
const header_bg = document.querySelector('.header-bg-container');

let lastScroll = 0;
const scrollThreshold = 150;

window.addEventListener('scroll', () => {
  // ✅ Skip hiding/showing if menu is open
  if (document.body.classList.contains('menu-open')) return;

  const currentScroll = window.scrollY;

  // Always show header at top
  if (currentScroll <= 0) {
    header.classList.remove('header-hidden');
    if (header_bg) header_bg.classList.remove('header-bg-hidden');

    lastScroll = 0;
    return;
  }

  // Ignore small scroll changes
  if (Math.abs(currentScroll - lastScroll) < scrollThreshold) return;

  if (currentScroll > lastScroll) {
    // scrolling down
    header.classList.add('header-hidden');
    if (header_bg) header_bg.classList.add('header-bg-hidden');
  } else {
    // scrolling up
    header.classList.remove('header-hidden');
    if (header_bg) header_bg.classList.remove('header-bg-hidden');
  }

  lastScroll = currentScroll;
});